var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnlargement = function SvgEnlargement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C77AC4",
    d: "M8.992 8.993a.5.5 0 0 1 .707 0l4.942 4.942V9.383a.5.5 0 0 1 1 0v5.879a.5.5 0 0 1-.5.5H9.26a.5.5 0 0 1 0-1h4.793L8.992 9.7a.5.5 0 0 1 0-.707ZM6.62.24a.5.5 0 0 1 0 1H1.946l4.65 4.65.065.079a.5.5 0 0 1-.772.628l-4.65-4.65V6.62a.5.5 0 0 1-.999 0V.74a.5.5 0 0 1 .5-.5h5.88Z"
  })));
};
export default SvgEnlargement;